/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenImportsCtrlDetails", [
		"$scope", "Utils", "$uibModal", "OpenImportsService", "AdminClientsService", "importData", "actionReport", "okinaJobData", "reportDetails", "$controller", "$interval","$route", "CONSTANTS",
		function ($scope, Utils, $uibModal, OpenImportsService, AdminClientsService, importData, actionReport, okinaJobData, reportDetails, $controller, $interval,$route,  CONSTANTS) {

		$controller("OpenImportsCtrlParent", {$scope: $scope});

		$scope.data = {
			importData: importData.data,
			importParameters: {},
			actionReport: actionReport.data.action_report,
			validationReport: {},
			detailMode: true,
			okinaJobStatus: okinaJobData.data,
			display: {},
			reportDetails: reportDetails.data.reportDetails
		};


		let refId;

		let hasImportProcessInEvents = function(importData){
			return importData.events.some(event => event.action.includes('IMPORT'));
		}


		let getImportData = function () {
			// if($scope.data.currentFilter === $scope.data.filters.UNLIMITED) {
			OpenImportsService.getMobiitiImports(refId)
				.then((response) => {
					$scope.data.imports = response.data.filter(importData => importData.fileName !== null && hasImportProcessInEvents(importData));
					feedLevel1ValidationData();
				});
		};

		let getCompleteImportJob = function () {
			for (const currImport of $scope.data.imports){
				if (Array.isArray(currImport.events)){
					for (const currEvent of currImport.events){
						if (parseInt($route.current.params.id) == parseInt(currEvent.chouetteJobId)){
							return currImport;
						}
					}
				}
			}
		}


		let getLevel1ValidationId = function () {
			let completeJob = getCompleteImportJob();
			if (completeJob == null || completeJob === 'undefined'){
				return ;
			}

			for (const currEvent of completeJob.events){
				if (currEvent.action === 'VALIDATION_LEVEL_1' && currEvent.chouetteJobId != null){
					return currEvent.chouetteJobId;
				}
			}
		}



		let feedLevel1ValidationData = function () {
			let level1ValId = getLevel1ValidationId();

			if (level1ValId == null || level1ValId === 'undefined'){
				return ;
			}

			OpenImportsService.getValidationReport($scope.data.importData.referential, level1ValId)
				.then((response) => {
					$scope.data.level1ValidationReport = response.data.validation_report;
				});
		};

		AdminClientsService.getReferentialId().then((data) => {
			refId = data;
			getImportData();
		});


		var jobStatusCheckerFunction;

		// On monitore pour rafraichir la page
		if ($scope.data.importData.status === "STARTED") {

			jobStatusCheckerFunction = $interval(function () {
				OpenImportsService.getImport($scope.data.importData.referential, $scope.data.importData.id).then((response) => {
					const jobData = response.data;
					$scope.data.importData = jobData;

					// JOB Terminé => on stoppe la fonction périodique
					if (jobData.status === "TERMINATED" || jobData.status === "ABORTED") {
						stopCheckerFunction();

						// On démarre ensuite un nouveau monitoring pour vérifier la complétion des actions Okina à la suite de l'import IEV.
						OpenImportsService.okinaJobStatusChecker($scope.data.importData.referential, jobData.id);

						if (jobData.status === "TERMINATED") {
							$scope.data.okinaJobStatus = "OKINA_UPDATE_IN_PROGRESS";
						} else if (jobData.status === "ABORTED") {
							$scope.data.okinaJobStatus = "ABORTED";
						}

					}

					// JOB toujours en cours => on récupère le rapport d'action pour MAJ de la progression
					else {
						OpenImportsService.getActionReport($scope.data.importData.referential, $scope.data.importData.id).then((response) => {
							$scope.data.actionReport = response.data;
							$scope.data.globalValue = $scope.data.actionReport.progression.current_step;
							$scope.data.globalMaxValue = $scope.data.actionReport.progression.steps_count;
							$scope.data.subtaskValue = $scope.data.actionReport.progression.steps[$scope.data.actionReport.progression.current_step - 1].realized;
							$scope.data.subtaskMaxValue = $scope.data.actionReport.progression.steps[$scope.data.actionReport.progression.current_step - 1].total;
						});
					}
				});
			}, 3000);
		}

		if ($scope.data.okinaJobStatus !== "TERMINATED" && $scope.data.okinaJobStatus !== "ABORTED") {
			OpenImportsService.okinaJobStatusChecker($scope.data.importData.referential, $scope.data.importData.id);
		}

		$scope.$on(CONSTANTS.EVENT_IMPORT_COMPLETE, function () {

			OpenImportsService.getActionReport($scope.data.importData.referential, $scope.data.importData.id).then((response) => {
				if (actionReport.result === "OK") {
					$scope.data.okinaJobStatus = "TERMINATED";
					$scope.data.actionReport = response.data;
					displayData();
					OpenImportsService.getValidationReport($scope.data.importData.referential, $scope.data.importData.id)
						.then((response) => {
							$scope.data.validationReport = response.data.validation_report;
						});
				} else {
					$scope.data.okinaJobStatus = "ABORTED";
					$scope.data.actionReport = actionReport;
				}
			});


		});


		/**
		 * Stopper la fonction périodique de vérification de statut du job.
		 */
		function stopCheckerFunction() {
			if (angular.isDefined(jobStatusCheckerFunction)) {
				$interval.cancel(jobStatusCheckerFunction);
				jobStatusCheckerFunction = undefined;
			}
		}


		/**
		 * Pour être sur que la fonction est détruite lorsqu'on change de page.
		 */
		$scope.$on("$destroy", function () {
			/* Cette condition empêche de savoir si un import est terminé quand on ne se trouve plus sur la page d'import
			if (OpenImportsService.jobCheckerFunctions[$scope.data.importData.id]) {
				$interval.cancel(OpenImportsService.jobCheckerFunctions[$scope.data.importData.id]);
			}
			*/
			stopCheckerFunction();
		});


		/**
		 * On récupère les données pour affichage des détails de l'import
		 * (on est obligé d'utiliser cette fonction car l'ordre des données dans le fichier json peut varier d'un import à l'autre)
		 */


		function displayData(){
			if($scope.data.actionReport.objects === undefined) return;
			if(!$scope.data.actionReport.objects) return;
			$scope.data.actionReport.objects.forEach(function(object){
				if(object.stats !== undefined)
					$scope.data.display[object.type] = object.stats[object.type];
			});
		}
		displayData();

		/**
		 * Si on veut afficher le détail d'un import terminé on va chercher le validation report
		 */

		function getVReport(){
			if($scope.data.okinaJobStatus === "TERMINATED"){
				OpenImportsService.getValidationReport($scope.data.importData.referential, $scope.data.importData.id)
					.then((response) => {
						$scope.data.validationReport = response.data.validation_report;
					});
			}
		}
		getVReport();


		$scope.getTypeLabel = function () {
			let fallback = $scope.data.importData.type ? $scope.data.importData.type.toUpperCase() : "";

			if (!Array.isArray($scope.data.imports)) {
				return fallback;
			}

			let completeJob = getCompleteImportJob();
			if (completeJob == null) {
				return fallback;
			}

			switch (completeJob.type) {
				case 'GTFS_FULL_FLEX':
					return "GTFS flex";
				case 'GTFS_FLEX':
					return "GTFS + GTFS flex";
				default:
					return fallback;
			}
		};

		$scope.getErrorDescription = function (error) {

			switch (error) {
				case "3_route_7":
					return "Une route doit avoir au moins un journey pattern";
				case "3_route_rutebanken_4":
					return "Une route doit avoir au moins 2 route points"
				default:
					return "";
			}
		};

		$scope.getDetail = function(error) {
			let reportDetail = $scope.data.reportDetails.filter(reportDetail => reportDetail.controlCode === error.test_id);

			if(reportDetail.length > 0){
				let detail = reportDetail[0].details;
				if(error.source !== undefined) {
					if (Array.isArray(error.source)) {
						for (let i = 0; i < error.source.length; i++) {
							detail = detail.replaceAll("%{source_" + i + "_label}", error.source[i].label);
							detail = detail.replaceAll("%{source_" + i + "_objectid}", error.source[i].objectid);
							detail = detail.replaceAll("%{source_" + i + "_objectid}", error.source[i].objectid);
						}
					} else {
						detail = detail.replaceAll("%{source_label}", error.source.label);
						detail = detail.replaceAll("%{source_objectid}", error.source.objectid);
					}
				}
				if(error.target !== undefined){
					if(Array.isArray(error.target)){
						for (let i = 0; i < error.target.length; i++) {
							detail = detail.replaceAll("%{target_" + i + "_label}", error.target[i].label);
							detail = detail.replaceAll("%{target_" + i + "_objectid}", error.target[i].objectid);
						}
					}
					else{
						detail = detail.replaceAll("%{target_label}", error.target.label);
						detail = detail.replaceAll("%{target_objectid}", error.target.objectid);
					}
				}

				detail = detail.replaceAll("%{error_value}", error.error_value);
				detail = detail.replaceAll("%{reference_value}", error.reference_value);

				return detail;

			}
			return "";
		};


	}])
	.filter('uniqueBy', function () {
		return function (value, key) {
			var seen = {};
			var result = [];
			for (var i = 0; i < value.length; i++) {
				var val = value[i];
				var currentKey = val[key];
				if (!seen[currentKey]) {
					seen[currentKey] = true;
					result.push(val);
				}
			}
			return result;
		};
	});
